export default __webpack_public_path__ + "static/media/chibi-dental.09378503.png";